export default {
  API_URL: 'https://neoenergy-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://neoenergysandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
